import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const ConsumptionFactorBarHorizontalChart = ({
  data,
  width = 700,
  height = 300,
}) => {
  const svgRef = useRef();

  useEffect(() => {
    if (!data?.length) return;

    d3.select(svgRef.current).selectAll("*").remove();

    const margin = { top: 20, right: 70, bottom: 40, left: 80 };

    const chartWidth = 350; // or width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    const svg = d3
      .select(svgRef.current)
      .attr("width", width)
      .attr("height", height);

    const chart = svg
      .append("g")
      .attr(
        "transform",
        `translate(${margin.left},${margin.top})`
      );

    // Ensure x-axis always starts at 0 and has a valid range
    const maxValue = d3.max(data, (d) => d.value) || 0;

    const x = d3
      .scaleLinear()
      .domain([0, Math.max(1, maxValue)])
      .nice()
      .range([0, chartWidth]);

    // Y Scale
    const y = d3
      .scaleBand()
      .domain(data.map((d) => d.name))
      .range([0, chartHeight])
      .padding(0.3);

    // X Axis
    chart
      .append("g")
      .attr("transform", `translate(0, ${chartHeight})`)
      .call(d3.axisBottom(x));

    // Y Axis
    chart.append("g").call(d3.axisLeft(y));

    // Bars
    chart
      .selectAll("rect")
      .data(data)
      .enter()
      .append("rect")
      .attr("x", 0)
      .attr("y", (d) => y(d.name))
      .attr("height", y.bandwidth())
      .attr("width", (d) => x(d.value))
      .attr("rx", 5)
      .attr("fill", "#4e79a7");

    // Value Labels
    chart
      .selectAll(".label")
      .data(data)
      .enter()
      .append("text")
      .attr("class", "label")
      .attr("x", (d) => x(d.value) + 8)
      .attr("y", (d) => y(d.name) + y.bandwidth() / 2)
      .attr("dy", "0.35em")
      .style("font-size", "12px")
      .style("fill", "#333")
      .text((d) => d.value);

  }, [data, width, height]);

  return <svg ref={svgRef}></svg>;
};

export default ConsumptionFactorBarHorizontalChart;